import React from "react";
import "./WhiteLabelSolution.css";

const WhiteLabelSolution = () => {
  return (
    <div>
      <p>this is WhiteLabelSolution</p>
      <p>this is WhiteLabelSolution</p>
      <p>this is WhiteLabelSolution</p>
      <p>this is WhiteLabelSolution</p>
      <p>this is WhiteLabelSolution</p>
      <p>this is WhiteLabelSolution</p>
      <p>this is WhiteLabelSolution</p>
      <p>this is WhiteLabelSolution</p>
      <p>this is WhiteLabelSolution</p>
      <p>this is WhiteLabelSolution</p>
      <p>this is WhiteLabelSolution</p>
      <p>this is WhiteLabelSolution</p>
      <p>this is WhiteLabelSolution</p>
      <p>this is WhiteLabelSolution</p>
      <p>this is WhiteLabelSolution</p>
      <p>this is WhiteLabelSolution</p>
      <p>this is WhiteLabelSolution</p>
      <p>this is WhiteLabelSolution</p>
      <p>this is WhiteLabelSolution</p>
      <p>this is WhiteLabelSolution</p>
    </div>
  );
};

export default WhiteLabelSolution;
